var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uF059 copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Loop-Optimise",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LO-connect---solar-1.1.1-accordian",
    transform: "translate(-892, -627)",
    fill: "#AFB6B9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(483, 119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419,528 C424.520833,528 429,523.520833 429,518 C429,512.479167 424.520833,508 419,508 C413.479167,508 409,512.479167 409,518 C409,523.520833 413.479167,528 419,528 Z M420.25,520.5 L417.75,520.5 C417.515625,520.5 417.333333,520.317708 417.333333,520.083333 L417.333333,519.614583 C417.333333,518.351562 418.596354,517.270833 419.520833,516.854167 C420.315104,516.489583 420.666667,516.151042 420.666667,515.473958 C420.666667,514.901042 419.898438,514.367188 419.065104,514.367188 C418.596354,514.367188 418.166667,514.523438 417.945312,514.679688 C417.697917,514.861979 417.4375,515.096354 416.825521,515.877604 C416.747396,515.981771 416.617188,516.033854 416.5,516.033854 C416.408854,516.033854 416.317708,516.007812 416.252604,515.955729 L414.533854,514.653646 C414.364583,514.523438 414.3125,514.289062 414.429688,514.106771 C415.549479,512.244792 417.138021,511.333333 419.260417,511.333333 C421.5,511.333333 424,513.117188 424,515.5 C424,517.479167 422.645833,518.234375 421.65625,518.794271 C421.044271,519.145833 420.666667,519.783854 420.666667,520.083333 C420.666667,520.317708 420.484375,520.5 420.25,520.5 Z M420.25,524.666667 L417.75,524.666667 C417.515625,524.666667 417.333333,524.484375 417.333333,524.25 L417.333333,521.75 C417.333333,521.515625 417.515625,521.333333 417.75,521.333333 L420.25,521.333333 C420.484375,521.333333 420.666667,521.515625 420.666667,521.75 L420.666667,524.25 C420.666667,524.484375 420.484375,524.666667 420.25,524.666667 Z",
    id: "\\uF059-copy-2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.8c25e73bcfde3d2138484da172be2664.svg";
export { ForwardRef as ReactComponent };